export const GET_PETPOINTS = 'GET_PETPOINTS';
export const GET_PETPOINTS_LOADING = 'GET_PETPOINTS_LOADING';
export const GET_PETPOINTS_ERROR = 'GET_PETPOINTS_ERROR';

export const GET_PETPOINTS_BY_ID = 'GET_PETPOINTS_BY_ID';
export const GET_PETPOINTS_BY_ID_LOADING = 'GET_PETPOINTS_BY_ID_LOADING';
export const GET_PETPOINTS_BY_ID_ERROR = 'GET_PETPOINTS_BY_ID_ERROR';

export const GET_PET_POINTS_EVENTS = 'GET_PET_POINTS_EVENTS';
export const GET_PET_POINTS_EVENTS_LOADING = 'GET_PET_POINTS_EVENTS_LOADING';
export const GET_PET_POINTS_EVENTS_ERROR = 'GET_PET_POINTS_EVENTS_ERROR';

export const GET_PET_POINTS_EVENTS_MIGRATE = 'GET_PET_POINTS_EVENTS_MIGRATE';
export const GET_PET_POINTS_EVENTS_MIGRATE_LOADING = 'GET_PET_POINTS_EVENTS_MIGRATE_LOADING';
export const GET_PET_POINTS_EVENTS_MIGRATE_ERROR = 'GET_PET_POINTS_EVENTS_MIGRATE_ERROR';

export const GET_PET_POINTS_EVENTS_APPLICATION = 'GET_PET_POINTS_EVENTS_APPLICATION';
export const GET_PET_POINTS_EVENTS_APPLICATION_LOADING = 'GET_PET_POINTS_EVENTS_APPLICATION_LOADING';
export const GET_PET_POINTS_EVENTS_APPLICATION_ERROR = 'GET_PET_POINTS_EVENTS_APPLICATION_ERROR';

export const MIGRATE_PET_POINT_EVENT = 'MIGRATE_PET_POINT_EVENT';
export const MIGRATE_PET_POINT_EVENT_LOADING = 'MIGRATE_PET_POINT_EVENT_LOADING';
export const MIGRATE_PET_POINT_EVENT_ERROR = 'MIGRATE_PET_POINT_EVENT_ERROR';
export const MIGRATE_PET_POINT_EVENT_RESET_STATE = 'MIGRATE_PET_POINT_EVENT_RESET_STATE';

export const CREATE_PET_POINT_EVENT = 'CREATE_PET_POINT_EVENT';
export const CREATE_PET_POINT_EVENT_LOADING = 'CREATE_PET_POINT_EVENT_LOADING';
export const CREATE_PET_POINT_EVENT_ERROR = 'CREATE_PET_POINT_EVENT_ERROR';
export const CREATE_PET_POINT_EVENT_RESET_STATE = 'CREATE_PET_POINT_EVENT_RESET_STATE';

export const DELETE_PET_POINT_EVENT = 'DELETE_PET_POINT_EVENT';
export const DELETE_PET_POINT_EVENT_LOADING = 'DELETE_PET_POINT_EVENT_LOADING';
export const DELETE_PET_POINT_EVENT_ERROR = 'DELETE_PET_POINT_EVENT_ERROR';
export const DELETE_PET_POINT_EVENT_RESET_STATE = 'DELETE_PET_POINT_EVENT_RESET_STATE';

export const UPDATE_PET_POINT_EVENT = 'UPDATE_PET_POINT_EVENT';
export const UPDATE_PET_POINT_EVENT_LOADING = 'UPDATE_PET_POINT_EVENT_LOADING';
export const UPDATE_PET_POINT_EVENT_ERROR = 'UPDATE_PET_POINT_EVENT_ERROR';
export const UPDATE_PET_POINT_EVENT_RESET_STATE = 'UPDATE_PET_POINT_EVENT_RESET_STATE';

export const PET_POINTS_RESET_STATE = 'PET_POINTS_RESET_STATE';
